export default __webpack_public_path__ + "static/media/paymentfailed-man.b7876255.webp";